<template>
  <Card :title="$t('global.auto-letsencrypt-certificate')">
    <ToggleCard :label="$t('global.enable')" :description="$t('global.auto-letsencrypt-desc')">
      <template #toggle>
        <Toggle
          @change="onToggle"
          :value="getToggleValue()"
          :transitioning="isProcessing()"
          :disabled="!isLoaded()"
        />
      </template>
    </ToggleCard>
    <template v-if="getToggleValue()">
      <hr />
      <LetsEncryptIssueCertForm :site="site" />
    </template>
  </Card>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import Card from "@/components/display/Card";
import LetsencryptDisableModal from "@/components/smart/modals/LetsencryptDisable";
import LetsencryptEnableModal from "@/components/smart/modals/LetsencryptEnable";
import LetsEncryptIssueCertForm from "@/components/smart/forms/LetsEncryptIssueCertForm";
import store from "@/store";
import Toggle from "@/components/display/Toggle";
import ToggleCard from "@/components/display/card-sub-components/CardToggle";

export default {
  name: "LetsEncrypt",
  components: {
    Card,
    Toggle,
    ToggleCard,
    LetsEncryptIssueCertForm,
  },
  props: {
    site: Object,
  },
  setup(props) {
    const letsencryptEnabled = computed(() => store.getters["letsencrypt/getEnabled"]);
    const toggleEnabled = ref(false);
    const enabledStatus = computed(() => store.getters["letsencrypt/getEnabledStatus"]);
    const isProcessing = () => enabledStatus.value.isLoading;
    const isLoaded = () => enabledStatus.value.isLoaded;

    // getToggleValue gets the current state (true/false) of the toggle
    // handles cases where toggle needs to be reversed if the user clicks 'cancel' in a modal
    const getToggleValue = () => {
      // if both the new toggle value and the real status of letsencrypt are equal, return the real status
      if (letsencryptEnabled.value === toggleEnabled.value) {
        return letsencryptEnabled.value;
      }
      // otherwise return the new toggle value.
      return toggleEnabled.value;
    };

    const onToggle = () => {
      // if letsencrypt is currently enabled, open disable modal
      if (letsencryptEnabled.value) {
        // tentatively set the enabled to false
        toggleEnabled.value = false;
        store.dispatch("modals/open", {
          template: LetsencryptDisableModal,
          data: { site: props.site },
          close: () => {
            // if the user cancels, set enabled back to true (no action taken)
            toggleEnabled.value = true;
          },
        });
        // else enable letsencrypt
      } else {
        // tentatively set the enabled to 'true'
        toggleEnabled.value = true;
        store.dispatch("modals/open", {
          template: LetsencryptEnableModal,
          data: { site: props.site },
          close: () => {
            // if the user cancels, set enabled back to 'false' (no action taken)
            toggleEnabled.value = false;
          },
        });
      }
    };

    onMounted(() => {
      // get current status of letsencrypt on this site
      store.dispatch("letsencrypt/getLetsEncryptStatus", props.site.id).then((isEnabled) => {
        // if letsencrypt is enabled, fetch info about it
        if (isEnabled) {
          toggleEnabled.value = isEnabled;
          // get general info about this site's letsencrypt installation
          return store.dispatch("letsencrypt/getInfo", props.site.id);
        }
      });
    });

    return { onToggle, letsencryptEnabled, toggleEnabled, getToggleValue, isProcessing, isLoaded };
  },
};
</script>
